import { render, staticRenderFns } from "./HomeTextTwo.vue?vue&type=template&id=185aa44e&scoped=true&"
import script from "./HomeTextTwo.vue?vue&type=script&lang=js&"
export * from "./HomeTextTwo.vue?vue&type=script&lang=js&"
import style0 from "./HomeTextTwo.vue?vue&type=style&index=0&id=185aa44e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185aa44e",
  null
  
)

export default component.exports